import styled from "styled-components"

// 각 input의 이름을 지정
const ModalInputName = styled.p`
    width: 4rem;
`

export default ModalInputName